"use client";

import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { FlexColumn, FlexRowAlignCenter } from "@/components/Flex";
import { themeColors } from "@/utils/themeColors";
import br from "@/styles/breakpoints.module.css";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import { useAuthSlideContextSelector } from "@/features/Auth/AuthSlide/hook/useAuthSlideContext";
import { AuthSignupSocialBtns } from "../Auth/components/styled/SocialButtons";
import ClickableText from "@/components/styled/button/ClickableText";
import Image from "next/image";
import { ASSETS_URL } from "@/config/deployConstants";

const UnauthJoinClassPage = () => {
    const openAuthSlide = useAuthSlideContextSelector(state => state.openAuthSlide);

    return (
        <FlexRowAlignCenter
            style={{
                padding: "4rem",
                backgroundColor: themeColors.neutralWhite,
                gap: "1rem 4rem",
                margin: "auto",
                borderRadius: "2rem",
                border: `1px solid ${themeColors.neutral1}`,
            }}
            className={br.smDownColumnReverse}>
            <FlexColumn style={{ flex: 1 }}>
                <h1
                    className="heading4"
                    style={{ marginBottom: "0.8rem" }}
                    data-testid="auto-id-07505f1b-3549-46c9-bc7a-a27d2d373921">
                    Sign up to join a class!
                </h1>
                <p style={{ marginBottom: "4rem" }} data-testid="auto-id-c8a1bed1-a2fb-4372-8cd3-8a992f6ee86d">
                    Join a class to access assignments, activities, and resources all in one place.
                </p>

                <AuthSignupSocialBtns event={AuthEvent.GENERAL_SIGNUP} />

                <FlexRowAlignCenter style={{ gap: "2.2rem", margin: "4rem 0" }}>
                    <div
                        style={{ flex: 1, border: `2px solid ${themeColors.background}` }}
                        data-testid="auto-id-64664b8f-2018-4827-a476-0ec5f85a76ce"
                    />
                    <span className="tertiaryTextBold1" data-testid="auto-id-135a4ccd-9378-422d-bd44-c4a534e2fd0e">
                        or
                    </span>
                    <div
                        style={{ flex: 1, border: `2px solid ${themeColors.background}` }}
                        data-testid="auto-id-0ce3f020-4825-45dd-9c10-282f513c96d7"
                    />
                </FlexRowAlignCenter>

                <FlexColumn style={{ alignItems: "center", gap: "1rem", flex: 1 }}>
                    <CircularRectTextButton
                        onClick={() => openAuthSlide({ event: AuthEvent.JOIN_CLASS, showSignupPage: true })}
                        className="secondaryTextBold1"
                        sx={{
                            width: "25rem",
                            height: "4rem",
                            backgroundColor: themeColors.primary,
                            color: themeColors.primaryDark,
                        }}>
                        Sign Up
                    </CircularRectTextButton>
                    <ClickableText
                        className={"bold"}
                        onClick={() => openAuthSlide({ event: AuthEvent.JOIN_CLASS, showLoginPage: true })}>
                        Already have an account? Log In
                    </ClickableText>
                </FlexColumn>
            </FlexColumn>
            <Image
                src={`${ASSETS_URL}/images/kai-waving.svg`}
                alt="join class"
                width={300}
                height={380}
                style={{ padding: "4rem", objectFit: "contain", flex: 0.8, maxWidth: "100%" }}
            />
        </FlexRowAlignCenter>
    );
};

export default UnauthJoinClassPage;
